import { Component, input, output } from '@angular/core';
import { IAddressHistory, ICOBHistory, ICoverageHistory, IEligHistory, IPersonHistory, ITransactions } from '../../store/summaryOfChanges/state';

@Component({
    selector: 'app-summary-details-page',
    templateUrl: './summary-details.component.html',
    styleUrls: ['./summary-details.component.scss'],
    standalone: false
})
export class SummaryDetailsComponent {
  backSearch = output<boolean>();
  readonly memberEligHistory = input<IEligHistory[]>([]);
  readonly cobHistory = input<ICOBHistory[]>([]);
  readonly coverageHistory = input<ICoverageHistory[]>([]);
  readonly personHistory = input<IPersonHistory[]>([]);
  readonly addressHistory = input<IAddressHistory[]>([]);
  readonly transaction = input<ITransactions>({} as ITransactions);


}
